export class GetCreditsResponse {
    'totalRemainingCredits';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalRemainingCredits",
            "baseName": "totalRemainingCredits",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GetCreditsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
